@if (viewStateSupportsLayout() && shouldShowLayoutOptions()) {
    <st-list-drop-down
        class="st-live-view-options__layout"
        labelPosition="after"
        [value]="viewStateLayoutValue()"
        [label]="languageSettings?.PSTWebViewLabel"
        [list]="viewStateLayoutOptions()?.Options"
        (valueOutput)="updateLayout($event)" />
}
@if (viewStateSupportsGroupBy()) {
    <st-list-drop-down
        class="st-live-view-options__group-by"
        mobileIcon="workspaces"
        [label]="languageSettings?.PSTWebGroupByLabel"
        [value]="viewStateGroupByValue()"
        [list]="viewStateGroupByOptions()?.Options"
        (valueOutput)="updateGroupBy($event)" />
}
@if (viewStateSupportsGroupByOrder()) {
    <button
        mat-icon-button
        (click)="updateGroupSortOrder()">
        <mat-icon class="material-symbols-outlined">{{ selectCurrentGroupByOrderIcon() }}</mat-icon>
    </button>
}
@if (viewStateSupportsSortBy()) {
    <st-list-drop-down
        class="st-live-view-options__sort-by"
        mobileIcon="sort"
        [value]="viewStateSortByValue()"
        [label]="languageSettings?.PSTWebSortByLabel"
        [list]="viewStateSortByOptions()?.Options"
        (valueOutput)="updateSortBy($event)" />
}
@if (viewStateSupportsSortByOrder()) {
    <button
        mat-icon-button
        (click)="updateSortOrder()">
        <mat-icon class="material-symbols-outlined">{{ selectCurrentSortByOrderIcon() }}</mat-icon>
    </button>
}

@if (newlyAddedItems()?.length) {
    <button
        mat-button
        class="st-live-view-options-button-new-items"
        [matMenuTriggerFor]="newItemsMenu">
        {{ newItemsCountLabel() }}
    </button>
    <mat-menu
        #newItemsMenu="matMenu"
        class="st-live-view-options-button-new-items__menu">
        <ng-template matMenuContent>
            @for (rundown of newlyAddedItems(); track rundown?.Guid) {
                <st-live-card-item
                    small="true"
                    [cardViewType]="cardViewType.SMALL"
                    [data]="rundown"
                    (rundownOpenEmitter)="openRundown(rundown)" />
            }
        </ng-template>
    </mat-menu>
}
